import { render, staticRenderFns } from "./NovaExtincao.vue?vue&type=template&id=3d43a799"
import script from "./NovaExtincao.vue?vue&type=script&lang=js"
export * from "./NovaExtincao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports